import { createSlice } from "@reduxjs/toolkit";
import {
  eventMetaInitialState,
  eventSelectedState,
  initialState,
  selectedState
} from "./metaInterface";

const INIT_STATE: initialState = {
  contentCategory: [],
  contentDomain: [],
  contentRegion: [],
  contentSubCategory: {},
  contentUsage: []
};

const INIT_STATE_EVENT: eventMetaInitialState = {
  eventCategory: [],
  eventDomain: [],
  eventRegion: [],
  eventSubCategory: {},
  eventUsage: []
};

const SELECTED_STATE: selectedState = {
  contentCategory: [],
  contentDomain: [],
  contentRegion: [],
  contentSubCategory: [],
  contentUsage: [],
  defaultTag: []
};

const SELECTED_STATE_EVENT: eventSelectedState = {
  eventCategory: [],
  eventDomain: [],
  eventRegion: [],
  eventSubCategory: [],
  eventUsage: [],
  defaultTag: []
};

export const LpMetaSlice = createSlice({
  name: "LpMetaSlice",
  initialState: INIT_STATE,
  reducers: {
    addMetaData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const SelectedMeta = createSlice({
  name: "SelectedMetaSlice",
  initialState: SELECTED_STATE,
  reducers: {
    addSelectedMetaData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    resetSelectedMetaData: () => SELECTED_STATE
  }
});

export const eventMetaSlice = createSlice({
  name: "EventMetaSlice",
  initialState: INIT_STATE_EVENT,
  reducers: {
    addEventMetaData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const SelectedEventMeta = createSlice({
  name: "SelectedEventMetaSlice",
  initialState: SELECTED_STATE_EVENT,
  reducers: {
    addSelectedEventMetaData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    resetSelectedEventMetaData: () => SELECTED_STATE_EVENT
  }
});

export const { addSelectedMetaData, resetSelectedMetaData } =
  SelectedMeta.actions;

export const { addSelectedEventMetaData, resetSelectedEventMetaData } =
  SelectedEventMeta.actions;
